<template>
    <HeaderList>
        <template #content>
            <h1 class="name">{{ account.name || '-' }}<div class="indicator" :class="account.status ? 'active' : 'inactive'"></div></h1>
            <p>{{ account.url || '-' }}</p>
        </template>
    </HeaderList>
</template>

<script>
    import { mapState } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import HeaderList from '@/components/sections/HeaderList';

    export default {
        name: "DashboardHeader",
        components: {
            HeaderList
        },
        computed: {
            ...mapState(useAccountStore, ['account']),
        }
    }
</script>
